import {
  PRINT_ROWNO_FIELD,
  clampColMm,
  contentWidthMm,
} from './printLayout';

const EDGE_PX = 8;

function attrEscape(field) {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(field);
  }
  return String(field).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function applyColWidth(doc, field, mm) {
  const sel = `table.list col[data-field="${attrEscape(field)}"]`;
  const col = doc.querySelector(sel);
  if (col) col.style.width = `${mm}mm`;
  const th = doc.querySelector(`table.list thead th[data-field="${attrEscape(field)}"]`);
  if (th) th.setAttribute('data-width-mm', String(mm));
}

function snapshotMm(doc, layout) {
  const table = doc.querySelector('table.list');
  if (!table) return { columnWidthsMm: {}, rowNumberWidthMm: 12 };
  const tablePx = table.getBoundingClientRect().width || 1;
  const pxPerMm = tablePx / contentWidthMm(layout);
  const columnWidthsMm = {};
  let rowNumberWidthMm = Number(layout?.rowNumberWidthMm) || 12;
  doc.querySelectorAll('table.list thead th[data-field]').forEach((th) => {
    const field = th.getAttribute('data-field');
    const mm = clampColMm(th.getBoundingClientRect().width / pxPerMm, 20);
    if (field === PRINT_ROWNO_FIELD) rowNumberWidthMm = mm;
    else columnWidthsMm[field] = mm;
  });
  return { columnWidthsMm, rowNumberWidthMm };
}

/**
 * 미리보기 표 헤더 오른쪽 경계 드래그 → 열 폭(mm).
 * 드래그 중에는 iframe DOM만 바꾸고, mouseup에서 onCommit.
 */
export function bindPrintColumnResize(doc, { layout, onCommit }) {
  if (!doc) return () => {};
  const table = doc.querySelector('table.list');
  if (!table) return () => {};

  let drag = null;

  const onDown = (e) => {
    const th = e.target.closest?.('th.resize-col');
    if (!th) return;
    const rect = th.getBoundingClientRect();
    if (rect.right - e.clientX > EDGE_PX) return;
    e.preventDefault();
    e.stopPropagation();
    const field = th.getAttribute('data-field');
    if (!field) return;
    const snap = snapshotMm(doc, layout);
    drag = {
      field,
      startX: e.clientX,
      startMm:
        field === PRINT_ROWNO_FIELD
          ? snap.rowNumberWidthMm
          : snap.columnWidthsMm[field] || 20,
      snap,
    };
  };

  const onMove = (e) => {
    if (!drag) return;
    const tablePx = table.getBoundingClientRect().width || 1;
    const pxPerMm = tablePx / contentWidthMm(layout);
    const dxMm = (e.clientX - drag.startX) / pxPerMm;
    const next = clampColMm(drag.startMm + dxMm, drag.startMm);
    applyColWidth(doc, drag.field, next);
  };

  const onUp = () => {
    if (!drag) return;
    const field = drag.field;
    const snap = drag.snap;
    const th = doc.querySelector(`table.list thead th[data-field="${attrEscape(field)}"]`);
    const tablePx = table.getBoundingClientRect().width || 1;
    const pxPerMm = tablePx / contentWidthMm(layout);
    const mm = th
      ? clampColMm(th.getBoundingClientRect().width / pxPerMm, drag.startMm)
      : drag.startMm;
    const columnWidthsMm = { ...snap.columnWidthsMm };
    let rowNumberWidthMm = snap.rowNumberWidthMm;
    if (field === PRINT_ROWNO_FIELD) rowNumberWidthMm = mm;
    else columnWidthsMm[field] = mm;
    drag = null;
    onCommit?.({ columnWidthsMm, rowNumberWidthMm });
  };

  doc.addEventListener('mousedown', onDown);
  doc.addEventListener('mousemove', onMove);
  doc.addEventListener('mouseup', onUp);
  window.addEventListener('mouseup', onUp);
  window.addEventListener('mousemove', onMove);

  return () => {
    doc.removeEventListener('mousedown', onDown);
    doc.removeEventListener('mousemove', onMove);
    doc.removeEventListener('mouseup', onUp);
    window.removeEventListener('mouseup', onUp);
    window.removeEventListener('mousemove', onMove);
  };
}
